import GenericBannerPrice from '../../../../../pages/vip/features/generic-banner-price/generic-banner.mobile';

export default GenericBannerPrice;
